import script from "./ComponentRichText.vue?vue&type=script&lang=js"
export * from "./ComponentRichText.vue?vue&type=script&lang=js"

import "./ComponentRichText.vue?vue&type=style&index=0&id=7d03acdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d03acdf"]])

export default __exports__